const HIDE_DETAIL = 'hideDetail';

export { HIDE_DETAIL };



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCardDetails.constants.js